import Notice from "~/components/shared/Notice/Notice";
import { Job } from "~/components/build/Show/lib/types";

interface Props {
  job: Job;
}

const StackFinished = ({ job }: Props) => {
  if (job.type !== "script") {
    return null;
  }
  if (!job.stackFinished) {
    return null;
  }
  const message = "This job has been finished successfully by agent stack.";

  return (
    <Notice title={message} noticeType="notice" icon="heroicons/16/solid/exclamation-triangle">
      <p>
        {" "}
        Check the <strong>Timeline</strong> tab for more information.{" "}
      </p>
    </Notice>
  );
};

export default StackFinished;
